import React, { Component } from 'react'
import { Button, Drawer, Form } from 'antd';
import Swal from "sweetalert2";
import moment from 'moment';

class ExtendKontrak extends Component {
    constructor() {
        super();
        this.state = {
            loading: false
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.props.changeState({
            [name]: value
        })
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        })

        let form = {
            id: this.props.data.contract_id,
            duration: this.props.data.contract_duration,
        }

        this.props.request("kontrak/perpanjang", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.props.changeState({
                        extend_visible: false,
                        contract_id: '',
                        contract_type: '',
                        contract_start: '',
                        contract_duration: '',
                        contract_note: '',
                        contract_status: ''
                    }, () => {
                        this.props.loadData()
                    })
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    loading: false
                })
            });
    }

    render() {
        const contractType = this.props.data.contract_type ? this.props.data.contract_type.toUpperCase() : '-';
        const contractStart = this.props.data.contract_start ? moment(this.props.data.contract_start).format('ll') : '-';

        return (
            <Drawer
                zIndex={2000}
                title="Perpanjang Kontrak"
                width={350}
                onClose={() => {
                    this.props.changeState({ extend_visible: false });
                }}
                visible={this.props.data.extend_visible}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={() => {
                            this.props.changeState({
                                extend_visible: false,
                                contract_duration: ''
                            });
                        }}
                                style={{ marginRight: 8 }}>
                            Batal
                        </Button>
                        <Button onClick={this.handleSubmit} disabled={this.state.loading || !this.props.data.contract_duration || Number(this.props.data.contract_duration) <= 0} type="primary">
                            {this.state.loading ?
                                <><i className={"fa fa-refresh fa-spin"}></i> Loading</>
                                :
                                "Simpan"
                            }
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical" hideRequiredMark>
                    <div className="mb-3" style={{ fontSize: '13px' }}>
                        <div><strong>Tipe Kontrak:</strong> {contractType}</div>
                        <div><strong>Kontrak Mulai:</strong> {contractStart}</div>
                    </div>
                    <div className="form-group">
                        <label>Durasi Kontrak <small>(Durasi dalam Bulan)</small></label>
                        <input
                            name="contract_duration"
                            className="form-control col-xl-12 col-md-12"
                            placeholder="Durasi Kontrak..."
                            value={this.props.data.contract_duration}
                            type="number"
                            min={1}
                            required
                            onChange={this.handleChange}
                        />
                    </div>
                </Form>
            </Drawer>

        )
    }
}

export default ExtendKontrak
